import m from "./../../../dist/es2015/locales/ko_KR.js";
export const am5locales_ko_KR = m;